export default __webpack_public_path__ + "static/media/PR-Card-wnl-1.dbcc4fa8.jpg";